import { JupiterTheme, CloseButton } from '@jupiterone/jupiter-web-toolkit';
import {
  AppBar,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import ClassTileContainer from './ClassTileContainer';
import CreateEntityForm from './CreateEntityForm';
import useCreateEntityModal, { HookProps } from './useCreateEntityModal';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    appBar: {
      background: theme.palette.coolGrey[700],
      display: 'flex',
    },
    closeButton: {
      color: '#fff',
      opacity: 0.75,
      marginRight: -16,
      '&:hover': {
        opacity: 1,
      },
    },
    backButton: {
      color: '#fff',
      opacity: 0.75,
      marginLeft: -16,
      '&:hover': {
        opacity: 1,
      },
    },
    title: {
      color: 'white',
      flex: 1,
    },
    dialogPaper: {
      background: theme.palette.coolGrey[50],
      boxShadow: 'none',
    },
    dialogContent: {
      paddingTop: '70px',
      paddingBottom: '40px',
      width: '600px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    expandedDialogContent: {
      paddingTop: '70px',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '100%',
      [theme.breakpoints.up('md')]: {
        width: '80%',
      },
    },
  })
);
interface Props extends HookProps {
  open: boolean;
}
const CreateEntityModal = ({ open, ...props }: Props) => {
  const classes = useStyles();
  const {
    state,
    handleBack,
    closeModal,
    handleSaveEntity,
    handleSelectClass,
    handleBulkUpload,
  } = useCreateEntityModal(props);

  return (
    <Dialog
      open={open}
      fullScreen={true}
      TransitionComponent={Transition}
      classes={{ paper: classes.dialogPaper }}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          {!state.showClassPage && (
            <IconButton
              className={classes.backButton}
              onClick={handleBack}
              aria-label="Close"
            >
              <ChevronLeft />
            </IconButton>
          )}
          <Typography variant="h6" className={classes.title}>
            {props.mode === 'create' ? 'Add' : 'Edit'}&nbsp; Entity
          </Typography>
          <CloseButton
            onClose={closeModal}
            className={classes.closeButton}
            aria-label="Close"
          />
        </Toolbar>
      </AppBar>
      {state.selectedClass ? (
        open ? (
          <div className={classes.dialogContent}>
            <CreateEntityForm
              onSaveEntity={handleSaveEntity}
              busy={state.busy}
              selectedClass={state.selectedClass}
              selectedClassName={state.selectedClassName}
              entity={props.entity}
              isIntegrationEntity={state.isIntegrationEntity}
            />
          </div>
        ) : null
      ) : (
        <div className={classes.expandedDialogContent}>
          <ClassTileContainer
            onSelectClass={handleSelectClass}
            onBulkUpload={handleBulkUpload}
          />
        </div>
      )}
    </Dialog>
  );
};

export default CreateEntityModal;

const Transition = (props: any) => {
  return <Slide direction="up" {...props} />;
};
